import type { Button, Fabric, ResourceRef } from '@seddi/scene';
import type { TSurfaceMaterial } from '@seddi/surface-material';
import type { TSceneEntityEx, TSceneEx } from './sceneTypes';
import type { LogoDesc } from '../resources/logoTypes';

export const getResource = (ref: ResourceRef<any>, find: (id: string) => any) => {
  return typeof ref === 'object' ? ref : find(ref);
};

export const getResourceId = (ref: ResourceRef<any>): string => {
  return typeof ref === 'string' ? ref : ref.id;
};

type TSceneLike = {
  children: TSceneEx['children'];
};

/**
 * @deprecated
 */
export class Scene {
  // Filter entities with piece
  static filterWithPiece(scene: TSceneLike): TSceneEntityEx[] {
    return scene.children.filter((e) => e.components.garmentPiece);
  }

  // Filter entities with mesh
  static filterWithMesh(scene: TSceneLike): TSceneEntityEx[] {
    return scene.children.filter((e) => e.components.mesh);
  }

  // Filter entities with seam tapes
  static filterWithSeamTape(scene: TSceneLike): TSceneEntityEx[] {
    return scene.children.filter((e) => e.components.garmentSeam?.tape);
  }

  // Find entity with camera
  static findCamera(scene: TSceneLike): TSceneEntityEx | undefined {
    return scene.children.find((e) => e.components.camera);
  }

  // Find entity with environment
  static findEnvironment(scene: TSceneLike): TSceneEntityEx | undefined {
    return scene.children.find((e) => e.components.environment);
  }

  // Find entity with garment
  static findGarment(scene: TSceneLike): TSceneEntityEx | undefined {
    return scene.children.find((e) => e.components.garment);
  }

  // Find button
  static findButton(scene: TSceneEx, id: string): Button | undefined {
    return scene.buttons.find((b) => b.id === id);
  }

  // Find fabric
  static findFabric(scene: TSceneEx, id: string): Fabric | undefined {
    return scene.fabrics.find((f) => f.id === id);
  }

  // Find logo
  static findLogo(scene: TSceneEx, id: string): LogoDesc | undefined {
    return scene.logos.find((l) => l.id === id);
  }

  // Find material
  static findMaterial(scene: TSceneEx, id: string): TSurfaceMaterial | undefined {
    return scene.materials.find((m) => m.id === id);
  }
}

/**
 * Filter entities with model components.
 * @param scene - Scene descriptor.
 */
export const filterSceneModels = (scene: TSceneLike): TSceneEntityEx[] => {
  return scene.children.filter((e) => e.components.model);
};
